<template lang="pug">
    Modal(v-model="isModalOpened" :title="$t('global.reminderText')" @on-cancel="$emit('closeDependencyObjectAlert')")
        pre(v-html="reminderText")
        div(slot="footer")
            Button(type="primary" @click="dependencyConfig.hasPermission?$router.push({path: dependencyConfig.path}):$emit('closeDependencyObjectAlert')") {{dependencyConfig.hasPermission ?  $t(`rcmtable.towardsText`): $t(`rcmtable.confirmText`)}}
</template>

<script>
export default {
    name: "DependencyObjectModal",
    props: {
        isDependencyObjectAlertShown: { type: Boolean, default: false },
        dependencyConfig: { type: Object, default: {}, searchView: { type: String, default: "appProfile" } }
    },
    data() {
        return {
            isModalOpened: false
        };
    },
    watch: {
        isDependencyObjectAlertShown: {
            deep: true,
            immediate: true,
            handler: function(val) {
                this.isModalOpened = val;
            }
        }
    },
    computed: {
        reminderText() {
            if (this.dependencyConfig.hasPermission) {
                if (this.$i18n.locale == "en-US") {
                    return `To creat objects on this page, please go to <a href="${
                        this.dependencyConfig.path
                    }">${this.$t(`${this.dependencyConfig.name}.pageTitleText`)}</a> to configure an object first.`;
                } else {
                    return `欲創建此頁面物件，請先到<a href="${this.dependencyConfig.path}">${this.$t(
                        `${this.dependencyConfig.name}.pageTitleText`
                    )}</a>頁面進行配置。`;
                }
            }
            if (!this.dependencyConfig.hasPermission) {
                if (this.$i18n.locale == "en-US") {
                    return `To creat objects on this page, please contact your administrator to help you go to <b>${this.$t(
                        `${this.dependencyConfig.name}.pageTitleText`
                    )}</b> to configure an object.`;
                } else {
                    return `欲創建此頁面物件，請先聯絡管理員協助至<b>${this.$t(
                        `${this.dependencyConfig.name}.pageTitleText`
                    )}</b>頁面進行相關配置。`;
                }
            }
        }
    },
    mounted() {}
};
</script>


// WEBPACK FOOTER //
// src/components/DependencyObjectModal.vue